import { z } from "zod";
import { createGenevaRawGpsData } from "../../../tools/GenevaDefaults";
import type { RawGpsData } from "../../../types/Navigation";
import { definePersistedSlice } from "../runtime/definePersistedSlice";

/** Geneva-area defaults used when individual GPS fields are missing from storage. */
const genevaDefaults = createGenevaRawGpsData();

/** Zod schema mirroring {@link RawGpsData} with Geneva fallbacks per field. */
const LastGpsDataSchema = z.object( {
    "latitude":         z.number().default( genevaDefaults.latitude ),
    "longitude":        z.number().default( genevaDefaults.longitude ),
    "altitude":         z.number().default( genevaDefaults.altitude ),
    "heading":          z.number().default( genevaDefaults.heading ),
    "speed":            z.number().default( genevaDefaults.speed ),
    "timestamp":        z.number().default( () => Date.now() ),
    "accuracy":         z.number().default( genevaDefaults.accuracy ),
    "altitudeAccuracy": z.number().nullable().
        default( genevaDefaults.altitudeAccuracy ),
} );

/** Last known GPS fix used as map/search anchor when live GPS is unavailable. */
export type LastGpsDataState = RawGpsData;

/** Default snapshot (Geneva) before first successful GPS write. */
export const LAST_GPS_DATA_DEFAULT: LastGpsDataState = createGenevaRawGpsData();

/** Persisted slice: last raw GPS sample (eager at boot). */
export const lastGpsDataSlice = definePersistedSlice<LastGpsDataState>( {
    "key":            "lastGpsData",
    "currentVersion": 1,
    "storage":        "preferences",
    "eager":          true,
    "schema":         LastGpsDataSchema,
    "default":        () => LAST_GPS_DATA_DEFAULT,
    "migrations":     {},
} );
